import { useTranslation } from 'react-i18next';
import Row from '../../row';
import Col from '../../col';
import IBranchOverviewProps from './interfaces/IBranchOverviewProps';
import { IRegionLocations } from '../../../interfaces/IRegionLocations';
import { ILocation } from '../../../interfaces/ILocation';
import Resume from '../resume';

function BranchOverview({
    regionData,
    branchData,
    carrierContactData,
}: Readonly<IBranchOverviewProps>) {
    const { t } = useTranslation();

    const REGIONS_TITLE = t('RegioesAtendidas');

    const renderRegions = () => {
        return (
            <>
                <Row className="align-start">
                    {regionData.map((region: IRegionLocations) => {
                        return (
                            <Col
                                className="w-30 mr-10"
                                key={`region@${region.abbreviation}`}
                            >
                                <Row className="location-title">
                                    {t(region.name)}
                                </Row>
                                {renderLocations(region)}
                            </Col>
                        );
                    })}
                </Row>
                <Row className="align-start">
                    <Col className="text-start">
                        {!regionData.length && (
                            <h4>{t('SemRegiaoAtendida')}</h4>
                        )}
                    </Col>
                </Row>
            </>
        );
    };

    const renderLocations = (region: IRegionLocations) => {
        const data = region.locations;

        return (
            <>
                {data.map((location: ILocation) => {
                    return (
                        <Row
                            className="align-start"
                            key={`location@${location.id}`}
                        >
                            <Col className="text-start">
                                {location.code} - {location.name}
                            </Col>
                        </Row>
                    );
                })}
            </>
        );
    };

    return (
        <div className="clb-shape">
            <div className="shape">
                <div className="container">
                    <div className="infos">
                        <Resume
                            branchData={branchData}
                            carrierContactData={carrierContactData}
                        />
                    </div>

                    <div className="regions">
                        <h3 className="regions-title"> {REGIONS_TITLE} </h3>
                        <div>{renderRegions()}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BranchOverview;
